import { FC } from 'react'
import { YourReports } from 'src/charts/YourReports'
import classes from './customReporting.module.scss'
import { SummarySection } from './SummarySection'

export const CustomReporting: FC = () => {
  return (
    <div className={classes.customReporting}>
      <div className={classes.card}>
        <SummarySection />

        {/* variant="page" — the card above is this page's, so the widget drops
            its own background rather than nesting a card inside a card. */}
        <YourReports variant="page" />
      </div>
    </div>
  )
}
